import { format, parseISO } from "date-fns";

export const formatDate = (val, template) => {
    if(!template)
        template = "MM/dd/yyyy"
    if(!val)
        return null;
    console.log("VAL", val);
    if(Object.prototype.toString.call(val) === '[object Date]')
        val = val.toISOString();
    if(template === "MM/dd/yyyy" && val.slice(-1) === "Z")
        val = val.substring(0,10);
    

    return format(parseISO(val), template);
    
};
export const boolToYesNo = (val) => {
    if(val === true)
        return "Yes";
    else if(val === false)
        return "No";
    else return "";
};

export const maskSSN = (ssn) => {
    if(!ssn)
        return null;
    var ssnShow = ssn?.substr(ssn.length - 4);
    var ssnHidden = ssn?.substr(0, ssn.length - 4).replace(/[0-9]/g, "*");
    return ssnHidden + ssnShow;;
}

export const formatCurrency = (val, decimals) => {
    if(!val)
        return "$0";
    if(!decimals)
        decimals = 0;
    if(decimals === 0){
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            // These options are needed to round to whole numbers if that's what you want.
            minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
            maximumFractionDigits: decimals
        });
        return formatter.format(val);   
    }
    
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        maximumFractionDigits: decimals
      });
    return formatter.format(val);
};

export const displayStatus = (id) => {
    switch (id) {
        case 40:
            return "Send Employee/Contact data to JDE";
        case 50:
            return "Send Enrollments to JDE";
        case 60:
            return "Send Beneficiaries to JDE";
        case 65:
            return "Send to Laserfiche";
        case 70:
            return "Close";
        default:
            return "Unknown - need to add";
    }
}

